module.exports = __webpack_public_path__ + "static/img/serverSwiperThree.124527a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serverSwiperThree.png
// module id = ZwD/
// module chunks = 1